// extracted by mini-css-extract-plugin
export default {"container_title":"style_container_title__V87fP"};